export const graphInfoTexts = {

  // --- Dashboard principal ---

  concentricCycle:
    "Ce cercle visualise les phases de ton cycle menstruel : " +
    "Rouge (Règles), Vert (Phase Folliculaire), Orange (Fenêtre Ovulatoire) " +
    "et Violet (Phase Lutéale). Il te permet de te situer par rapport à ton rythme hormonal naturel.",

  concentricMental:
    "Récapitule tes tendances de concentration et de productivité. " +
    "La zone Orange indique les périodes où tu as noté une réflexion plus diffuse " +
    "(brouillard mental ou idées foisonnantes). La zone Rouge reflète les moments où tu as déclaré " +
    "une concentration et une estime de soi optimales. Utilise cette vue pour adapter tes tâches " +
    "prioritaires — calmes ou créatives.",

  concentricSport:
    "Synthétise ta perception de l'effort sur tes séances passées. " +
    "Le Vert Menthe correspond aux entraînements que tu as jugés 'faciles'. " +
    "Plus la couleur s'assombrit, plus le ressenti de l'effort a été intense. " +
    "C'est un indicateur précieux pour ajuster l'intensité de tes prochaines sessions.\n\n" +
    "Le savais-tu ? Beaucoup d'athlètes choisissent de placer leurs blocs de haute intensité " +
    "durant les phases où leur ressenti de l'effort est naturellement le plus bas (zones claires) " +
    "pour optimiser leur progression.",

  // --- Cartes du haut (4 carrés cycle) ---

  cardCycle:
    "Indique la durée moyenne de ton cycle complet (du premier jour des règles " +
    "au premier jour des suivantes). Cette donnée te permet d'anticiper tes phases " +
    "de performance mois après mois.",

  cardRegles:
    "Affiche la durée moyenne de ta phase de saignements. Le suivi de cette durée " +
    "aide à préciser tes prédictions de cycle pour mieux organiser tes compétitions " +
    "ou entraînements.",

  cardOvulation:
    "Indique la période estimée de ton ovulation. C'est un moment clé du cycle " +
    "où de nombreuses athlètes observent des pics d'énergie ou des variations de force.",

  cardSymptomes:
    "Récapitule le nombre de ressentis (physiques ou émotionnels) que tu as enregistrés ce mois-ci.\n\n" +
    "Le savais-tu ? Identifier tes symptômes récurrents te permet de ne plus les subir, " +
    "mais de les intégrer à ta stratégie de récupération. En comprenant leur origine, " +
    "tu peux mettre en place des méthodes pour mieux les gérer et en atténuer l'impact sur tes performances.\n\n" +
    "L'approche CycleGala : Chaque femme est unique. La clé est d'observer tes propres variations " +
    "et leur évolution au fil des mois plutôt que de te comparer à une moyenne.",

  // --- Graphiques détaillés ---

  recapMental:
    "Ce score reflète la moyenne de tes ressentis quotidiens sur les 30 derniers jours. " +
    "Un score de 100% correspond à un ressenti maximal (10/10) signalé chaque jour pour ces indicateurs. " +
    "Cette vue d'ensemble t'aide à identifier tes tendances de bien-être et à observer comment ton énergie, " +
    "ta concentration ou ton estime de soi évoluent au fil de tes cycles.",

  activiteSportive:
    "Ce graphique superpose l'évolution de ta Fréquence Cardiaque (FC) et ton RPE.\n\n" +
    "Le RPE (Rate of Perceived Exertion) : C'est ton échelle personnelle de ressenti de l'effort, " +
    "notée de 1 (très facile) à 10 (effort maximal). C'est l'indicateur le plus fidèle de ta charge interne.\n\n" +
    "Le savais-tu ? Ta fréquence cardiaque peut naturellement augmenter en fin de cycle (phase lutéale), " +
    "même au repos. À intensité égale, ton cœur bat un peu plus vite, ce qui peut accroître la sensation " +
    "d'essoufflement ou de fatigue. En suivant cette variation, tu comprends que ce n'est pas une baisse " +
    "de forme, mais une réponse physiologique normale.",

  dureePhasesChart:
    "Ce graphique retrace la durée de chacune de tes phases sur les derniers mois.\n\n" +
    "Pourquoi le suivre ? La régularité de tes phases est un excellent indicateur de ton équilibre général. " +
    "Observer une phase qui se rallonge ou se raccourcit permet de mettre en perspective ton niveau de fatigue, " +
    "ton intensité d'entraînement ou ton stress actuel.\n\n" +
    "L'approche Performance : Utilise ces tendances pour comprendre comment ton corps réagit à ta " +
    "programmation sportive ou à ta vie pro sur le long terme, et adapter tes périodes de récupération si nécessaire.",

  temperatureBasaleChart:
    "Cette courbe retrace ta température au réveil, jour après jour, sur ton cycle en cours.\n\n" +
    "Ce qu'il faut y lire : après l'ovulation, la progestérone fait monter ta température de " +
    "0,3 à 0,5 °C, et elle reste haute jusqu'aux règles suivantes. Ce n'est pas un pic isolé " +
    "mais un palier qui dure — c'est le décalage entre le « avant » et le « après » qui compte, " +
    "pas la valeur d'un matin.\n\n" +
    "La ligne de base : la moyenne de tes 6 dernières températures basses. Tant que ton " +
    "ovulation n'est pas confirmée, elle est provisoire et marque le niveau que ta température " +
    "devra dépasser trois matins d'affilée. Une fois l'ovulation confirmée, elle se fige sur le " +
    "niveau qui l'a validée.\n\n" +
    "Sur un cycle long, fais glisser la courbe du doigt pour la parcourir : elle s'ouvre " +
    "centrée sur ton ovulation, ou sur ton dernier relevé tant qu'elle n'est pas connue.\n\n" +
    "Les points creux sont les mesures que tu as signalées comme perturbées (nuit blanche, " +
    "fièvre, alcool) : elles restent affichées mais n'entrent pas dans le calcul, sans quoi " +
    "elles déclencheraient une fausse confirmation.\n\n" +
    "L'approche Performance : ta température confirme *a posteriori* que l'ovulation a eu lieu. " +
    "C'est elle qui transforme une phase estimée en phase certaine, et donc tes repères " +
    "d'entraînement en repères fiables.",

  evolutionMentalChart:
    "Ce graphique suit tes variations quotidiennes de Concentration, Productivité et Estime de soi " +
    "sur une échelle de 1 à 10.\n\n" +
    "Pourquoi le suivre ? Ton état mental n'est pas linéaire. Visualiser ces courbes te permet d'identifier " +
    "les moments de ton cycle où tu te sens la plus efficace et ceux où ton esprit demande plus de repos.\n\n" +
    "L'avantage CycleGala : Planifie tes tâches complexes lors de tes pics de concentration et privilégie " +
    "la récupération ou les tâches routinières quand tes courbes sont plus basses.",

  repartitionMois:
    "Ce graphique en anneau illustre la distribution de tes humeurs prédominantes sur les 30 derniers jours.\n\n" +
    "Pourquoi l'utiliser ? Il te donne une vision globale de ton climat émotionnel. " +
    "Mets ces pourcentages en perspective avec tes phases de cycle et ton volume d'entraînement. " +
    "Si une période est plus 'difficile', visualise sa part réelle sur l'ensemble de ton mois " +
    "pour mieux relativiser et préparer la suite.",

  fcChart:
    "Ce graphique compare ta FC au repos (ton niveau de base) et ta FC à l'effort (ton intensité de travail).\n\n" +
    "FC Repos basse : Ton corps est généralement dans sa fenêtre de récupération optimale. " +
    "C'est souvent le moment idéal pour les efforts explosifs, le fractionné ou la haute intensité.\n\n" +
    "FC Repos haute : Ton cœur travaille déjà un peu plus au repos. Tu atteindras tes zones de cardio " +
    "plus vite. Beaucoup d'athlètes privilégient alors l'endurance fondamentale ou la technique.\n\n" +
    "Le conseil CycleGala : Si tu cours, ne cherche pas à maintenir tes chronos habituels quand ta FC repos " +
    "est haute. Adapte-toi en ralentissant pour rester en endurance fondamentale — tu protégeras ta récupération " +
    "tout en continuant de progresser.",

  rpeChart:
    "Ce graphique affiche ton RPE (Rate of Perceived Exertion), ton niveau d'effort ressenti de 1 à 10. " +
    "Les points de couleur en bas indiquent la phase de ton cycle correspondante.\n\n" +
    "Repère tes zones de force : les phases où tes scores de RPE sont bas pour une même charge de travail " +
    "sont tes fenêtres de haute performance.\n\n" +
    "Identifie les phases de résistance : un RPE élevé (8 ou 9) sur des séances habituelles, " +
    "combiné à une phase spécifique, signale souvent que ton corps mobilise plus d'énergie pour récupérer.\n\n" +
    "Le conseil CycleGala : Planifie tes blocs intensifs durant tes zones fortes et privilégie la technique " +
    "ou la récupération active quand ton ressenti d'effort augmente naturellement.",

  essoufflementChart:
    "Ce graphique retrace ton ressenti respiratoire durant tes activités, de 'Repos' à 'Intense'.\n\n" +
    "Le savais-tu ? Durant la phase lutéale (après l'ovulation), la hausse de la progestérone stimule " +
    "naturellement ton centre respiratoire. Tu peux avoir l'impression d'être essoufflée plus rapidement, " +
    "même sur des efforts modérés. Ce n'est pas un manque d'entraînement.\n\n" +
    "Le conseil CycleGala : Si tu observes des pics d'essoufflement plus fréquents, ralentis légèrement " +
    "l'allure pour rester dans une zone de confort respiratoire, ou privilégie des séances plus courtes " +
    "avec plus de récupération.",

  // --- Espace coach : décryptage physiologique par phase du cycle ---
  //     (i) contextuel affiché sur la fiche sportive, à côté de la phase actuelle.

  coachPhaseRegles:
    "Phase Menstruelle (J1 à J5) — Reset, récupération et relance.\n\n" +
    "Profil hormonal : estrogènes et progestérone au plus bas. Le corps dépense de l'énergie pour " +
    "l'inflammation nécessaire à la desquamation de l'endomètre.\n\n" +
    "Physiologie & sport : contrairement aux idées reçues, une fois le premier jour critique passé " +
    "(souvent lié aux crampes), le profil hormonal bas se rapproche de celui d'un homme. Le corps est " +
    "physiologiquement prêt à tolérer de l'intensité ; la barrière est surtout psychologique et mécanique " +
    "(douleurs, congestion pelvienne).\n\n" +
    "Levier performance : prioriser la récupération active à J1-J2, puis basculer sur des séances de force " +
    "ou de PMA dès que la douleur s'estompe. La tolérance à la chaleur est excellente à cette période.\n\n" +
    "Nutrition & symptômes : miser sur le fer (associé à la vitamine C) pour compenser les pertes sanguines. " +
    "Anti-inflammatoires naturels (oméga-3, curcuma) pour limiter la surproduction de prostaglandines, " +
    "responsables des crampes utérines et des troubles digestifs.",

  coachPhaseFolliculaire:
    "Phase Folliculaire (J6 à J12) — La fenêtre de puissance.\n\n" +
    "Profil hormonal : remontée progressive et dominante des estrogènes. La progestérone reste basse.\n\n" +
    "Physiologie & sport : les estrogènes sont des hormones hautement anabolisantes. Ils améliorent la " +
    "sensibilité à l'insuline, l'utilisation du glucose et la force musculaire. C'est le moment idéal pour " +
    "surcharger l'entraînement.\n\n" +
    "Levier performance : période de force maximale, de haute intensité (intervalles, sprints) et de " +
    "développement de la masse musculaire. La capacité de récupération entre les séances est au plus haut.\n\n" +
    "Nutrition & symptômes : le corps utilise préférentiellement les glucides comme carburant — c'est le " +
    "moment de placer les séances intenses glycogénodépendantes. Symptômes généralement minimes ; l'énergie " +
    "mentale et la motivation (dopamine stimulée par les estrogènes) sont au zénith.",

  coachPhaseOvulation:
    "Phase Ovulatoire (J13 à J15) — Le pic énergétique… et la vigilance tendineuse.\n\n" +
    "Profil hormonal : pic massif d'estrogènes, pic de LH (hormone lutéinisante) et brève poussée de " +
    "testostérone.\n\n" +
    "Physiologie & sport : force brute et confiance en soi maximales grâce au cocktail estrogènes/testostérone. " +
    "Attention : au pic maximal, les estrogènes augmentent la laxité ligamentaire en modifiant la structure " +
    "du collagène.\n\n" +
    "Levier performance : chercher des records personnels (PR) en force ou en puissance, mais avec une " +
    "technique irréprochable. Le risque de blessure (notamment des ligaments croisés antérieurs) est " +
    "statistiquement plus élevé.\n\n" +
    "Nutrition & symptômes : l'ovulation peut causer une légère douleur pelvienne (mittelschmerz). Soutenir " +
    "le foie dans le métabolisme et l'élimination des estrogènes (légumes crucifères, hydratation) pour " +
    "éviter un effet de rebond inflammatoire.",

  coachPhaseLuteale:
    "Phase Lutéale (J16 à J28) — Endurance, pivot métabolique puis gestion du SPM.\n\n" +
    "━ Lutéale précoce (J16 à J22) — L'endurance et le pivot métabolique\n\n" +
    "Profil hormonal : chute post-ovulatoire des estrogènes, puis remontée conjointe avec l'apparition " +
    "massive de la progestérone (sécrétée par le corps jaune).\n\n" +
    "Physiologie & sport : la progestérone déplace le métabolisme vers l'utilisation des lipides (acides gras) " +
    "plutôt que des glucides. Le corps devient une machine à endurance mais perd en efficacité sur les efforts " +
    "explosifs. La température corporelle augmente d'environ 0,3 à 0,5 °C, ce qui élève la fréquence cardiaque " +
    "de repos et rend la tolérance à la chaleur plus difficile.\n\n" +
    "Levier performance : séances d'endurance fondamentale, sorties longues à intensité stable. Privilégier " +
    "le travail technique et l'économie de course.\n\n" +
    "Nutrition & symptômes : augmenter légèrement l'apport en glucides, car le corps mobilise plus " +
    "difficilement ses stocks de glycogène à cause de la progestérone. Hydratation accrue et apport en sodium " +
    "indispensables pour compenser l'effet diurétique de la progestérone.\n\n" +
    "━ Lutéale tardive (J23 à J28) — La chute hormonale et la gestion du SPM\n\n" +
    "Profil hormonal : en l'absence de nidation, le corps jaune dégénère. C'est l'effondrement simultané et " +
    "brutal des estrogènes et de la progestérone.\n\n" +
    "Physiologie & sport : le sevrage hormonal crée un stress systémique. Le système nerveux central est plus " +
    "sensible à la fatigue. La rétention d'eau migre de l'espace intracellulaire vers l'espace extracellulaire " +
    "(sensation de gonflement).\n\n" +
    "Levier performance : phase de décharge (deload) ou réduction du volume d'entraînement. Prioriser la " +
    "qualité du mouvement et le travail postural (Pilates, étirements, mobilité). Éviter de planifier des " +
    "séances tests ou des compétitions majeures.\n\n" +
    "Nutrition & élimination des symptômes :\n" +
    "• Contrer les fringales : la chute de sérotonine pousse vers le sucre — miser sur le magnésium " +
    "(système nerveux) et le complexe de vitamines B.\n" +
    "• Réduire le SPM : consommer du zinc et des antioxydants pour limiter l'inflammation prémenstruelle.\n" +
    "• Sommeil : la baisse de progestérone perturbe le sommeil — soigner la routine du soir (chambre fraîche " +
    "pour contrer l'hyperthermie).",
};
